<template>
  <div>
    <vx-card>
      <heading size="h1" style-size="h4" class="mb-5">Personal Presentation</heading>
      <p class="mb-5">Dress to Impress!</p>
      <p class="mb-5">
        How we present ourselves to others often informs the opinion they form of us. This is
        valuable knowledge to have and to consider.
      </p>
      <p class="mb-5">
        Let’s take a look at some of the general expectations employers may have when it comes to
        standards of personal presentation.
      </p>

      <div class="vs-row" style="display: flex; width: 100%">
        <div class="vs-col vs-xs-12 vs-sm-7 vs-lg-8">
          <h5 class="mb-5 text-bold">Grooming & Hygiene</h5>
          <ul class="default-list">
            <li>Make sure you and your clothes are clean.</li>
            <li>Make sure your hands and fingernails are clean.</li>
            <li>Wear deodorant or antiperspirant.</li>
            <li>
              Use little or no perfume or aftershave/cologne. You want to smell good but not
              overpowering.
            </li>
            <li>
              Have fresh breath and clean teeth. Don’t chew gum or breathe cigarette fumes over
              everyone.
            </li>
            <li>Have clean and neatly brushed hair.</li>
            <li>Young men should be clean-shaven or have neatly trimmed beards.</li>
            <li>Avoid nail polish and heavy make-up.</li>
          </ul>

          <h5 class="mb-5 text-bold">Clothing</h5>
          <ul class="default-list">
            <li>Dress neatly in ironed clothes.</li>
            <li>
              Choose clothing appropriate to the position and your workplace. Try to think of it as
              your work “uniform”.
            </li>
            <li>
              Reserve loud colours, ultra-fashionable styles, and message or slogan T-shirts for
              leisure time.
            </li>
            <li>
              Public contact, customer service, and professional positions will require a more
              formal and conservative style of dress e.g., a shirt with a collar and tie, dress
              pants (no jeans or track pants), socks, and lace-up shoes (not thongs, boots or
              runners) for boys; a skirt, or tailored pants, blouse, jacket, stockings, and low
              heeled shoes for girls.
            </li>
            <li>
              Construction, outdoor positions, or those with no customer contact require different,
              less formal clothing and boots, but keep safety in mind.
            </li>
            <li>Wear a hat and sufficient sunscreen when working outdoors.</li>
            <li>Shoes should be in good repair and well-polished.</li>
            <li>Simple clothes that fit properly and quiet colours are most suitable.</li>
            <li>
              Avoid very tight clothes, see-through tops, low necklines, bare midriffs, and short
              skirts.
            </li>
            <li>Wear minimal jewellery.</li>
            <li>
              Clothing and accessories do not have to be expensive or the latest fashion to make a
              good impression, but they should always be in good taste, clean, and well-pressed.
            </li>
            <li>Follow all rules for personal protective equipment (PPE).</li>
          </ul>
        </div>
        <div class="vs-col vs-xs-12 vs-sm-5 vs-lg-4 lg:pl-10 sm:pl-5">
          <img
            src="@/assets/images/workplace_preparation/new/personal_presentation.jpg"
            class="img-responsive"
            alt=""
          />
        </div>
      </div>
      <form id="form" class="mt-10" @submit.prevent="save">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-checkbox v-model="data.confirmed" name="confirmed"
              >I have read all the information in this module</vs-checkbox
            >
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full flex justify-between">
            <div>
              <button class="btn btn-primary btn-size-medium mr-3 mb-1">Submit</button>
              <router-link
                to="/student/workplace-preparation"
                class="btn btn-secondary btn-size-medium mb-1"
              >
                Back
              </router-link>
            </div>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
export default {
  computed: {
    data: {
      get: function () {
        return this.getModuleData();
      },
      set: function (d) {
        this.setModuleData(d);
      },
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isConfirmed() {
      return this.$store.getters['authStudent/preworkWorkplacePreparationModules'][
        this.$route.params.id
      ];
    },
    prework() {
      return this.$store.getters['authStudent/prework'];
    },
  },
  methods: {
    save() {
      this.saveModule(this.data);
    },
  },
  watch: {
    'prework.workplace_preparation_modules'() {
      const modules = this.prework.workplace_preparation_modules;
      if (modules && modules[2]) {
        this.data = modules[2];
      }
    },
  },
  mounted() {
    if (this.isConfirmed) this.data.confirmed = true;
  },
  beforeDestroy() {
    this.data.confirmed = false;
  },
  inject: ['saveModule', 'getModuleData', 'setModuleData'],
};
</script>
